import { render, staticRenderFns } from "./Survey.Question.TextBlock.vue?vue&type=template&id=77be00f3&"
import script from "./Survey.Question.TextBlock.vue?vue&type=script&lang=js&"
export * from "./Survey.Question.TextBlock.vue?vue&type=script&lang=js&"
import style0 from "./Survey.Question.TextBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol})
